import _ from 'lodash';
import getValidSubmissions from '@/containers/E4ImpactMBA/helpers/getValidSubmissions';

/**
 * Survey: PROJECT - BASELINE IMPACT
 * Question: Could you please share with us an estimate of your company's turnover for the past fiscal year (including possible branches)?
 * 
 * == baseline
 * turnover_t_1_turnover_amount
 * turnover_t_1_turnover_currency
 * 
 * Survey: PROJECT - FINAL IMPACT
 * Question: Could you please share with us an estimate of your company's turnover for the current year?
 * 
 * == final
 * turnover_t1_turnover_value
 * turnover_t1_turnover_currency
 * 
 * @param props 
 * @returns 
 */
export const entrepreneursThatIncreasedTheTurnoverTotalCalculation = (props: any) => {
    const {filteredBaseline, filteredFinal} = getValidSubmissions(
        props.baselineSubmissions,
        props.finalSubmissions
    );

    const groupedBaselineSubmissions = _.keyBy(filteredBaseline, 'uoa_id');
    const groupedFinalSubmissions = _.keyBy(filteredFinal, 'uoa_id');

    const mergedSubmissions = _.mergeWith(
        groupedBaselineSubmissions,
        groupedFinalSubmissions,
        (baselineSubmission, finalSubmission) => ({baselineSubmission, finalSubmission})
    );
    
    let increased = 0;
    let value = 0;
    const total = Object.keys(mergedSubmissions).length;

    for (const uoaId in mergedSubmissions) {
        const item = mergedSubmissions[uoaId];

        if (
            item.baselineSubmission &&
            item.finalSubmission &&
            item.baselineSubmission.turnover_t_1_turnover_currency === item.finalSubmission.turnover_t1_turnover_currency &&
            item.baselineSubmission.turnover_t_1_turnover_amount < item.finalSubmission.turnover_t1_turnover_value
        ) {
            increased++;
        }
    }

    if (total > 0) {
        value = increased / total * 100;
    }
        
    return value.toFixed(2);
}